<div *ngIf="show && config?.class !== 'v6'" class="content {{config?.class}}">
  <span *ngIf="!config?.class?.match('v2|v4|v5')" class="material-icons">arrow_drop_up</span>
  <div class="popover-container" [class]="config?.popupClass">
    <span class="p-title" *ngIf="config?.title">{{config?.title}}</span><span *ngIf="config?.class === 'v5'" class="material-icons">close</span>
    <span class="p-desc" *ngIf="config?.desc" [innerHTML]="config?.desc"></span>
    <span class="p-eg" *ngIf="config?.eg" (click)="config?.emitneed ? emit() : false">{{config?.eg}}</span>
  </div>
</div>

<div *ngIf="show && config?.class === 'v6'" class="content {{config?.class}}">
  <div class="popover-container">
    <p *ngIf="config?.social" class="popover-item"><mat-icon class="i-check">check_circle_outline</mat-icon> Facebook Verified</p>
    <p class="popover-item"><mat-icon class="i-check">check_circle_outline</mat-icon> <span>Email Verified</span></p>
    <p class="popover-item"><mat-icon class="i-check">check_circle_outline</mat-icon> <span>Identity Verified</span></p>
  </div>
  <span class="material-icons">arrow_drop_down</span>
</div>